{
  "customOrderHistory": {
    "sortOptions": {
      "label": "Sorteren op",
      "code": "Bestelling",
      "position": "Position",
      "state": "Status",
      "description": "Omschrijving",
      "orderDate": "Datum",
      "deliverKW": "Leveringsweek",
      "valutaDate": "Valuta Datum",
      "shippingCosts": "Shipping",
      "totalPrice": "Net",
      "netPrice": "Net",
      "orderState": "Status",
      "productCode": "Product",
      "orderedQuantity": "Aantal Bestellt",
      "deliveredQuantity": "Aantal Offen",
      "formattedDeliverKW": "Leveringsweek"
    },
    "sortDirections": "Sorteren >",
    "sortDirection": {
      "asc": "Oplopend",
      "desc": "Aflopend"
    },
    "states" : {
      "COMPLETED": "Bestellung erledigt",
      "RESERVED": "Reserviert",
      "SHIPPING": "In Zustellung",
      "WITH_OPEN_POSITIONS": "Bestellung hat offene Positionen"
    },
    "filter": {
      "OVERVIEW": "Overzicht",
      "OPEN": "Open",
      "REMAINS": "Nota overzicht"
    },
    "search": {
      "orders": "Bestelling",
      "orderDateFrom": "vanaf datum",
      "orderDateTo": "Tot",
      "uigOrderNumber": "UIG Ordernr.",
      "productCode": "Art. Nr.",
      "searchFor": "Zoeken naar",
      "searchForText": "(bijvoorbeeld: bestelling, artikel, termijn uit productinfo)"
    },
    "fileName": {
      "order": "Besteloverzicht",
      "overview": "Bestelling-Übersicht",
      "remains": "BestellungenRückständigePositionen"
    },
    "dialog": {
      "orderDelete": {
        "title": "Bestellung löschen",
        "body": "Wollen Sie den Bestellung wirklich löschen?"
      },
      "orderPositionDelete": {
        "title": "Position löschen",
        "body": "Wollen Sie die Position wirklich löschen?"
      }
    },
    "detail": {
      "orderNumber": "Bestelnr.:",
      "date": "Datum:",
      "note": "Opmerking:",
      "shippingCosts": "Verzendkosten:",
      "totalPrice": "Net:"
    },
    "buttons": {
      "search": "Zoeken",
      "reset": "Terug",
      "export": "Afdrukken/Exporteren",
      "cancel": "Afbreken",
      "update": "Aanpassen",
      "updateEntry": "Aanpassen",
      "updateAll": "Alle Ändern",
      "back": "Terug naar overzicht",
      "ok": "Ok",
      "cancelText": "Afbreken"
    },
    "orderNumber": "Bestelling",
    "date": "Datum",
    "status": "Status",
    "total": "Total",
    "returnToOverview": "Terug naar overzicht",
    "plannedDelivery": "Leveringsweek",
    "valutaDate": "Valuta Datum",
    "deliveryAddress": "Verzendadres",
    "customerReference": "Opmerking",
    "shippingCosts": "Shipping",
    "totalPrice": "Net",
    "sortByDate": "Besteldatum",
    "sortByOrderNumber": "Bestelling",
    "sortByStatus": "Status",
    "sortByPlannedDelivery": "Leveringsweek",
    "error": "Bestellingen konden niet worden opgehaald.",
    "errorOrder": "Bestelling kon niet worden opgehaald.",
    "errorCancelOrder": "Bestelling kon niet worden verwijderd.",
    "errorCancelOrderEntry": "Positie kon niet worden gewist.",
    "errorUpdateOrderEntries": "Update war nicht erfolgreich.",
    "errorExportOrder": "De bestelling kon niet worden geëxporteerd.",
    "successCancelOrder": "Bestellung wurde gelöscht.",
    "successCancelOrderEntry": "Position wurde gelöscht.",
    "successUpdateOrderEntries": "Update war erfolgreich.",
    "position": "Position",
    "productCode": "Product",
    "description": "omschrijving",
    "orderedQuantity": "Aantal",
    "deliveredQuantity": "Open",
    "deliveredQuantityNow": "Offen bisher",
    "deliveredQuantityNew": "Offen neu",
    "netPrice": "Net",
    "textReLs": "Text für Lieferschein/Rechnung:",
    "downloadInfo": "Het downloaden start automatisch zodra de export is voorbereid.",
    "noOrders": "Geen bestelingen gevonden.",
    "noOrder": "Bestellung nicht gefunden.",
    "startShopping": "Doorgaan met winkelen"
  },
  "customManufacturerCampaign": {
    "manufacturer": "Fabrikant",
    "campaign":  "ACTIE-ID",
    "productCode": "Art.-Nr.",
    "productInfo": "Omschrijving",
    "validFrom": "Van",
    "validTo" : "Tot",
    "validDate": "Tijdvak",
    "editableUntil":"Melding",
    "emptyTable": "Er zijn geen gegevens in de tabel",
    "error":"Verkooprapporten kon niet worden opgehaald.",
    "value": "Waarde (€)",
    "combiValue1": "K1:",
    "combiValue2": "K2:",
    "combiCampaign": "Kombi",
    "search" : {
      "productCode":"Art.-Nr.",
      "manufacturerNumber":"Fabrikant-Nr",
      "ean":"EAN",
      "campaignId":"Aktie",
      "manufacturerId":"Fabrikant",
      "showOldData": "Bekijk ouder",
      "all": "Alle"
    },
    "sortDirections": "Sorteren >",
    "sortDirection": {
      "asc": "Oplopend",
      "desc": "Aflopend"
    },
    "buttons": {
      "search": "Zoeken",
      "reset": "Terug",
      "import" :"Importeren",
      "instruction":"Instructies voor claimen verkooppremie",
      "delete": "Verwijderen",
      "add": "Toevoegen",
      "export": "Rapport maken",
      "downloadCalendar": "Agenda-item maken",
      "downloadCsv": "Download Übersicht"
    },
    "sortOptions": {
      "label": "Sorteren op",
      "manufacturer": "Fabrikant",
      "id":  "ACTIE-ID",
      "productCode": "Art.-Nr.",
      "productName": "Omschrijving",
      "validFrom": "Tijdvak van",
      "validTo" : "Tijdvak tot",
      "editableUntil":"Claimen TOT"
    },
    "import" : {
      "title":"Importeren via CSV-bestand:",
      "text":"Meerdere datarecords tegelijk importeren via een aangemaakt CSV-bestand.",
      "noFileSelected" :"Niets geselecteerd",
      "success" : "De import is succesvol afgerond.",
      "unauthorizedCampaignCode":"De actiecode uit de volgende regels is niet overgenomen omdat deze niet vereist is voor de actie:",
      "errors" : {
        "invalidFileType":"Het te importeren bestand is geen CSV!",
        "hasDuplicates":"Een of meer van deze serienummers zijn al ingevoerd voor de actie",
        "invalidEntries":"Een of meer van de geïmporteerde rijen bevatten onjuiste of ongeldige gegevens en zijn daarom niet geaccepteerd"
      }
    },
    "instructions": {
      "title": "Instructies voor verkoopmeldingen",
      "downloadLink": "hier beschikbare sjabloon",
      "informationParagraph": "<p>Je kunt zoeken op artikelnummer, fabrikantnummer, EAN en/of actie uitvoeren en de resultatenlijst daarop filteren. Je kunt de sortering ook vooraf instellen. Let op, als je oudere, verlopen acties wilt zien, vink dan het selectievakje “Ouder weergeven” aan.</p><p>Klik op de betreffende actieregel. Let op de periode waarin je de artikelen moet hebben verkocht (LEVERINGSPERIODE) en het tijdstip waarop je de melding moet hebben ingediend (MELDPERIODE).</p><p>Voer de serienummers en de verkoopdatum in, bij set-artikelen zoals digitale systeemcamera-sets – alleen het serienummer van de body opgeven.<br>Klik altijd op toevoegen (\"+\"), herhaal dit bij meerdere opgaves en klik daarna op Overnemen - de ingevoerde verkoopgegevens worden opgeslagen.</p><p>Je rapporten kunnen de volgende status hebben.</p>",
      "status1": "= “open” De gegevens kunnen binnen de meldperiode weer gewijzigd of verwijderd  worden.",
      "status2": "= “In uitvoering” De gegevens worden verwerkt en wijzigingen zijn niet meer mogelijk.",
      "status3": "= “Afgewezen” De uitbetaling is afgewezen.",
      "status4": "= “Geaccepteerd” Een credit wordt aangemaakt.",
      "importCsvParagraphTitle": "Importeren via CSV-bestand:",
      "importCsvParagraph": "Je kunt ook meerdere aanvragen tegelijk uploaden door een CSV-bestand te importeren in de opmaak als",
      "importCsvParagraphContinued":  ".<br>Met de knop ‘Maak rapport aan’ kun je de aanvragen voor één of meerdere acties exporteren als CSV-bestand.",
      "importCsvParagraphContinued2":  "",
      "importCsvTemplateHeader": "'Actie-ID; Artikelnummer; Serienummer; Verkoopdatum;2. Serien-Nr.;2. Bezeichnung;Kombi-Produkt K1;Serien-Nr. K1;Kombi-Produkt K2;Serien-Nr. K2'",
      "importCsvParagraphAfterTemplate": "(scheidingsteken: puntkomma) en er mag geen kopregel met de kolomnamen worden ingevoegd.",
      "close": "Sluiten"
    },
    "details": {
      "product": "Artikel",
      "manufacturerArticleNo": "Fabrik.-Art.Nr.",
      "title": "Verkooprapporten opnemen",
      "error": "Record verkoopsrapporten konden niet worden opgevraagd.",
      "serialNumbers": "Serial-NR.",
      "campaignCode":"Campagnecode",
      "salesDate": "Verkoop Datum",
      "updateParagraph": "Voer het serienummer en de verkoopdatum in, in het geval van set-items - b.v. B. Digitale SLR-sets - alleen het serienummer van de behuizing aub. Klik op \"+\" om toe te voegen, klik op het prullenbakpictogram om te verwijderen. <br>Opslaan - slaat de zichtbare gegevens op en verwijdert alle verwijderde gegevens.",
      "required": "(erforderlich)",
      "tradeInSerialNo":"2. SERIEN-NR.",
      "tradeInName":"OMSCHRIJVING",
      "combiArticles": "Kombi-Artikel",
      "combiArticleOptional": "2. Kombi-Artikel optional:",
      "combiProduct1": "K1: ",
      "combiProduct2": "K2: ",
      "combiSerialNumbers": "Kombi Serien-NR.",
      "placeholder_1": "Artikel 1 wählen",
      "placeholder_2": "Artikel 2 wählen"
    },
    "messages": {
      "deleteSuccess": "Het verkoopbericht is succesvol verwijderd",
      "deleteFailure": "Het verkoopbericht kon niet worden verwijderd",
      "updateSuccess": "Het verkoopbericht is met succes bijgewerkt",
      "updateFailure": "Een of meer van deze serienummers zijn al ingevoerd voor de actie"
    },
    "export": {
      "productInfo": "U kunt de export tot deze producten beperken door producten te selecteren:",
      "title": "Rapport als CSV export:",
      "heading": "Exporteren",
      "noResults": "Geen resultaten gevonden",
      "campaignCode":"Campagnecode",
      "fromDate": "Gevangen tussen",
      "toDate": "Opgenomen tot",
      "selectCampaignOptions":"Selecteer campagne(s) ..."
    },
    "states": {
      "processing": "In proces",
      "paid": "Betaald",
      "rejected": "Afgewezen"
    }
  },
  "customStockProtection": {
    "instructions": {
      "title": "Instructies voor voorraadcompensatie aanvraag",
      "downloadLink": "voorbeeld hier beschikbaar.",
      "informationParagraph": "Klik op een van de \u0022proces\u0022nummers (u kunt ervoor kiezen om het artikelnummer of het ringfotoproces direct in te voeren). <br/>Let hierbij op de periode waarin u de goederen die nog op voorraad zijn moet hebben gekocht (levertermijn) en de periode waarin u de boeking in RIO moet doen (rapportagetermijn).",
      "informationParagraphContinued":"<br/><p> <strong> Voer de serienummers in (maximaal 30 tekens mogelijk). <br/>Bij setartikelen - zoals: B. Systeemcamera's - a.u.b. alleen het serienummer van de behuizing invoeren!<br/> Scheiding door komma's of andere speciale tekens kan tot overdrachtsfouten leiden! </strong> </p> <p> <strong> Klik op Toevoegen met “+” en Opslaan </strong> - draagt ​​de ingevoerde serienummers over. <br/>Na de rapportageperiode worden alle processen voor aanpassing van de voorraadwaarde opnieuw gecontroleerd en vervolgens gecrediteerd. <p>",
      "importCsvParagraph": "Importeren via CSV-bestand: U kunt een CSV-bestand importeren op basis van",
      "importCsvParagraphContinued": " Hiermee upload u meerdere gegevensrecords tegelijk naar het systeem. Het  bestand moet bestaand uit afzonderlijke gegevens per regel in de vorm 'Artikelnummer; RF-transactienummer; Serienummer' (scheidingsteken: puntkomma) en er mogen geen koptekst met de kolomlabels zijn ingevoegd.",
      "statesHeader": "Volgende staus mogelijk",
      "close": "Sluiten"
    },
    "states": {
      "new": "Nieuwe voorraadcompensatie",
      "finishedWithCredit": "Aanvraag  verwerkt, creditnota aangemaakt",
      "finishedWithoutCredit": "Aanvraag verwerkt, geen creditnota aangemaakt",
      "01": "New stock value adjustment",
      "02": "In process Feedback, still pending",
      "03": "Dossier verwerkt, creditnota aangemaakt",
      "04": "Supplier check activated, but partially rejected",
      "05": "Process completed, credit note partially created",
      "06": "Dossier verwerkt, creditnota aangemaakt",
      "07": "Geen gegevens beschikbaar",
      "valid": "Ok",
      "invalid":"Serial number not known",
      "notfound": "Outside the reference period"
    },
    "search": {
      "articleNumber": "Artikel-Nr:",
      "scenario": "Sorteren op:"
    },
    "scenarioFilter": {
      "ALL": "Alle aanvragen bekijken",
      "CURRENT_UNFINISHED": "Alle actuele en onvolledige aanvragen",
      "COMPLETED_UNRECORDED": "Alle afgeronde of niet geregistreerde aanvragen"
    },
    "buttons": {
      "search": "Zoeken",
      "reset": "Terug",
      "delete": "Verwijderen",
      "add": "Toevoegen",
      "save": "Overnemen",
      "check": "Check",
      "import": "Start Import"
    },
    "sortOptions": {
      "label": "Sorteren op",
      "processNumber": "RF Proces",
      "state": "Status",
      "productCode": "ART. NR.",
      "productTitle": "omschrijving",
      "deliveryPeriodFrom": "Geleverd vanaf",
      "deliveryPeriodTo": "Geleverd tot",
      "reportingPeriodFrom": "Melding Van",
      "reportingPeriodTo": "Melding Tot",
      "value": "Bedrag",
      "currency": "Valuta"
    },
    "sortDirections": "Sorteren >",
    "sortDirection": {
      "asc": "Oplopend",
      "desc": "Aflopend"
    },
    "details":{
      "title": "Voorraadcompensatie - gegevens tonen",
      "error": "Stock value compensation details could not be retrieved.",
      "serialNumbers": "Serial-NR.",
      "deliveryStatus": "Lieferantenstatus",
      "updateParagraph": "Please enter the serial numbers once per line, in the case of set articles - please only enter the housing serial number -. Such as Digital SLR sets"
    },
    "deliveryStatus": {
      "001": "In supplier audit",
      "002": "Release for credit",
      "003": "Credit note created",
      "004": "Release for goodwill credit",
      "005": "Under test",
      "006": "Rejected",
      "007": "Rejected - Canon direct customer"
    },
    "uigProcess": "RF proces",
    "status": "Status",
    "articleNumber": "Art. Nr.",
    "productInfo": "omschrijving",
    "stockProtectionValue": "Bedrag",
    "stockProtectionCurrency": "Valuta",
    "error": "Voorraadwaardecompensatie kon niet worden opgehaald.",
    "fromDate":"van",
    "toDate": "Tot",
    "emptyTable": "Er zijn geen gegevens in de tabel",
    "noFileSelected": "Niets geselecteerd",
    "importTitle": "Importeren via CSV-bestand:",
    "importText": "Hier kunt u meerdere datarecords tegelijk importeren via een aangemaakt CSV-bestand.",
    "deliveryPeriodFrom": "Delivery Period From",
    "deliveryPeriodTo": "Delivery Period To",
    "reportingPeriodFrom": "Reporting Period From",
    "reportingPeriodTo": "Reporting Period To",
    "deliveryPeriod": "Leveringsperiode",
    "reportingPeriod": "Meldperiode",
    "manufacturerPrice": "Compensatie"
  },
  "customUserPayments": {
    "search": {
      "invoiceDateFrom": "vanaf datum",
      "invoiceDateTo": "Tot",
      "amountFrom": "Bedrag van",
      "amountTo": "Tot",
      "invoiceNumber": "Rekening/ boekings Nr.",
      "referenceNumber": "REF. NR.",
      "articleNumber": "Art. Nr.",
      "notificationNumber": "Advies. nr.",
      "orderType": "Type bestelling",
      "bookingType": "Soort boeking",
      "openPositions": "Alleen openstaande posten"
    },
    "sortOptions": {
      "label": "Sorteren op",
      "invoiceNumber": "Factuur",
      "referenceNumber": "Referentie",
      "invoiceDate": "Rek. /Boekingdatum",
      "dueDate": "Verschuldigd",
      "amount": "Bedrag",
      "debitOrCredit": "Debet / Credit",
      "deliveryStatus": "Lager / Str.",
      "notificationNumber": "Advies. nr.",
      "notificationDate": "A. Datum",
      "discount": "Skonto",
      "collectedAmount": "Incasso €",
      "accumulatedValue": "Akkum"
    },
    "sortDirections": "Sorteren >",
    "sortDirection": {
      "asc": "Oplopend",
      "desc": "Aflopend"
    },
    "bookingType": {
      "ALL": "Alle",
      "DEBIT": "Debet",
      "CREDIT": "Credit"
    },
    "orderType": {
      "ALL": "Alle",
      "CAMP": "Lager",
      "ROUTE": "Strecke"
    },
    "buttons": {
      "search": "Zoeken",
      "reset": "Terug",
      "export": "Afdrukken/Exporterenn",
      "back": "Terug naar overzicht",
      "exportOnly": "Exportieren"
    },
    "files":{
      "overview": "Kontoübersicht",
      "details": "Rechnungsdetails"
    },
    "details": {
      "deliveryNote": "Pakbon",
      "ourOrder": "RF Bestellnr.",
      "orderDate": "Bestelldatum",
      "valueDate": "Valuta Datum",
      "address": "Versandadresse",
      "totalAmount": "Rechnungsbeträge Endbetrag",
      "netAmount": "Netto",
      "tax": "MwSt.",
      "boxing": "Verpackung",
      "shipment": "Verzending",
      "discount1": "Rabatt 1:",
      "discount2": "Rabatt 2:",
      "invoiceTitle": "Rechnungs-Nr.:",
      "invoiceDate": "Rechnungsdatum:"
    },
    "avis": {
      "number": "Avis-Nr.:",
      "date": "Avis-Datum:",
      "balance": "Rechnungsbetrag:",
      "cashDiscount": "Skonto-Betrag:",
      "plannedAmount": "Einzugs-Betrag:",
      "warehouse": "Art",
      "accDocumentNumber": "Rechnungs-Nr.",
      "billingDate": "Rechnungs datum",
      "amount": "Rechnungs betrag",
      "cashDiscountTitle": "Skonto-betrag",
      "plannedAmountTitle": "Einzugs-/Gut schriftbetrag"
    },
    "invoice": "Factuur",
    "reference": "REF. NR.",
    "invoiceDate": "Factuurdatum",
    "dueDate": "Vervaldatum",
    "amount": "Bedrag",
    "debitOrCredit": " Debet / Credit",
    "warehouseOrThirdparty": "Magazijn /leveranciers",
    "notificationNo": "Advies nr.",
    "notificationDate": "Advies datum",
    "discountValue": "Bet. Korting",
    "collectionAmount": "Incasso bedrag",
    "accumulatedValue": "Geaccumuleerd",
    "pdf": "PDF",
    "balanceWarehouse": "Saldo (alleen magazijn):",
    "balanceThirdParty": "Saldo (alleen leveranciers):",
    "balance": "Saldo:",
    "downloadInfo": "Het downloaden start automatisch zodra de export is voorbereid.",
    "errorExportInvoiceOverview": "Die Rechnungsverwaltung konnte nicht exportiert werden.",
    "emptyTable": "Er zijn geen gegevens in de tabel",
    "open": " = Open",
    "closed": " =  Afgehandeld",
    "error": "Rekeningoverzicht kon niet worden opgehaald.",
    "pdfError": "PDF kon niet worden opgehaald.",
    "errorExportInvoiceDetails": "Die Rechnungsdetails konnte nicht exportiert werden."
  },
  "deliveryNotes": {
    "sortOptions": {
      "label": "Sorteren op",
      "orderNumber": "Bestelnummer",
      "position": " Bestelpositie-Nr.",
      "productCode": "Art.-Nr.",
      "deliveredQuantity": "Aantal",
      "unit": "Colli",
      "description": "omschrijving",
      "imei": "IMEI-apparaat nummer",
      "deliveryNumber": "Pakbon",
      "deliveryMethod": "Verzendwijze",
      "releaseDate": "Vrijgave",
      "weightKG": "Gewicht in kg",
      "units": "Colli",
      "trackingUrl": "Track en Trace"
     },
    "sortDirections": "Sorteren >",
    "sortDirection": {
      "asc": "Oplopend",
      "desc": "Aflopend"
    },
    "states" : {
    },
    "filter": {
    },
    "search": {
      "deliverynotes": "Pakbonnen",
      "deliveryDateFrom": "vanaf datum",
      "deliveryDateTo": "Tot",
      "deliveryId": "Pakbon Nr.",
      "productCode": "Art. Nr."
    },
    "fileName": {
      "overview": "Pakbonnen overzicht",
	    "delivery": "Pakbonnen",
      "pdf": "Pakbon"
    },
    "dialog": {
    },
    "detail": {
      "deliveryNumber": "Bestelnummer:",
      "deliveryMethod": "Verzendwijze",
      "deliveryText": "Text:",
      "formattedReleaseDate": "Vrijgave:",
      "releaseDate": "Vrijgave:",
      "trackingCode": "Track en Trace:",
      "trackingUrl": "Track en Trace:",
      "weightKG": "Gewicht in kg:",
      "units": "Colli:",
      "pdfUrl": "PDF:",

      "orderNumber": "Bestelnummer",
      "position": "Bestelpositie-Nr.",
      "productCode": "Art.-Nr.",
      "deliveredQuantity": "Aantal",
      "unit": "Colli",
      "description": "omschrijving",
      "imei": "IMEI-apparaat nummer"
    },
    "buttons": {
      "search": "Zoeken",
      "reset": "Terug",
      "export": "Afdrukken/Exporteren",
      "back": "Terug naar overzicht",
      "ok": "Ok",
      "cancelText": "Abort"
    },
    "returnToOverview": "Terug naar overzicht",
    "deliveryNumber": "Pakbon",
    "deliveryMethod": "Verzendwijze",
    "formattedReleaseDate": "Vrijgave",
    "trackingCode": "Track en Trace",
    "weightKG": "Gewicht in kg",
    "units": "Colli",
    "pdfUrl": "PDF",
    "sortByDate": "Date",
    "sortByOrderNumber": "Order Nr.",
    "sortByStatus": "Status",
    "sortByPlannedDelivery": "Delivery CW",
    "error": "Leveringsbon kon niet worden opgehaald",
    "errorDeliveryNote": "Leveringsbon kon niet worden opgehaald.",
    "errorExportOrder": "De bestelling kan niet worden geëxporteerd.",
    "errorExportPdf": "Leveringsbon (pdf) kon niet worden aangemaakt.",
    "position": "Position",
    "productCode": "Article",
    "description": "omschrijving",
    "orderedQuantity": "Aantal",
    "deliveredQuantity": "Open",
    "deliveredQuantityNow": "Open now",
    "deliveredQuantityNew": "Open new",
    "netPrice": "Net price",
    "textReLs": "Text for delivery note/invoice:",
    "downloadInfo": "Het downloaden start automatisch zodra de export is voorbereid.",
    "noDeliveryNotes": "Geen Pakbonnen gevonden.",
    "noDeliveryNoteItems": "No delivery note items found.",
     "startShopping": "Doorgaan met winkelen",
     "trackingUrl": "Track en Trace",
     "trackingLink": "Tracking"
  },
  "statistic": {
    "errorExportPdf": "Statistiek (pdf) kon niet worden gemaakt."
  },

  "customVendorReporting": {
    "emptyTable": "Er zijn geen gegevens in de tabel",
    "error": "Leveranciersrapportage kon niet worden opgehaald",
    "downloadInfo": "Het downloaden start automatisch zodra de export is voorbereid.",
    "errorExportDataEvaluation": "Die Bestellung konnte nicht exportiert werden.",
    "search" : {
      "productCode":"Item Nr.",
      "manufacturerNumber":"Fabrikantnr.",
      "ean":"EAN",
      "manufacturer":"Fabrikant",
      "reportTransferType": "Type",
      "reportTransferStatus": "Toestand",
      "reportTransferPeriod": "Verslagperiode",
      "all": "Alle",
      "transferDateFrom": "van",
      "transferDateTo": "tot",
      "transferPeriodLabel":"Zeitraum",
      "showTransferredOnly": "Toon overgedragen exemplaren",
      "b2bUnit":"B2BUnit",
      "partnerID":"PartnerID",
      "reportCategory": "Report-Kategorie",
      "reportChannel": "Kanaal"

    },
    "sortDirections": "Sorteervolgorde",
    "sortDirection": {
      "asc": "Oplopend",
      "desc": "Aflopend"
    },
    "buttons": {
      "search": "Zoeken",
      "reset": "Resetten naar standaard",
      "import" :"Import",
      "instruction":"Gids voor leveranciersrapportage",
      "save": "gegevens opslaan",
      "toggleEdit": "Wijzig de ingediende gegevens",
      "add": "Gegevens in de rapportregel worden niet opgeslagen als ze niet zijn toegevoegd met de + knop!"
    },
    "sortOptions": {
      "label": "Sorteer op",
      "reportTransferPeriod":"Verslagperiode",
      "transferDate":"Rapportage dag",
      "timeStamp":"Overdrachtstijd",
      "fileName":"bestandsnaam",
      "b2bUnit":"B2BUnit"

    },
    "import" : {
      "title":"Importeren via CSV-bestand:",
      "text":"Importeer meerdere datasets tegelijk via een aangemaakt CSV-bestand.",
      "noFileSelected" :"Geen geselecteerd",
      "messages" :{
        "success" : "De import is succesvol afgerond.",
        "invalidFileType":"Het te importeren bestand is geen CSV!",
        "incorrectData":"Item nr. {{productCode}} - de regel bevat fouten, controleer dit. Er zijn geen gegevens geïmporteerd.",
        "invalidProduct": "Item nr. {{productCode}} - de regel bevat fouten, controleer dit. Er zijn geen gegevens geïmporteerd.",
        "duplicateData": "Het bestand bevat duplicaten. Controleer!",
        "invalidFileName": "Filnavnet er forkert.",
        "transferDataNotFound": "Het bestand kon niet correct worden toegewezen. Controleer dit!",
        "branchNotFound":"Store ID {{productCode}} - de regel bevat fouten, controleer dit. Er zijn geen gegevens geïmporteerd.",
        "branchNotVendorReportingEnabled":"Store ID {{productCode}} is gedeactiveerd voor leveranciersrapportage, controleer dit. Er zijn geen gegevens geïmporteerd.",
        "invalidInventoryDate":"Item nr. {{productCode}} - Ongeldige inventarisdatum, zou {{inventoryDate}} moeten zijn. Controleer!"
      }
    },
    "manufacturer" : "Fabrikant",
    "reportTransferType" : "Type",
    "reportTransferPeriod" : "Verslagperiode",
    "transferDate" : "Rapportage dag",
    "timestamp" : "Verzonden",
    "reportTransferStatus" : "Toestand",
    "dataCount" : "Gegevensrecords",
    "quantity" : "Opnames",
    "reportTransferStatuses" : {
      "Open" : "Open",
      "Success" : "Succes",
      "NoData" : "Geen gegevens",
      "DataModified" : "Gewijzigde gegevens",
      "Error" : "Fout"
    },
    "reportTransferTypes" : {
      "Sales" : "Sales",
      "Inventory": "Inventory"
    },
    "reportChannelTypes" : {
      "General" : "General",
      "Online" : "Online",
      "Store" : "Store"
    },
    "fileName" : "Bestandsnaam",
    "details": {
      "title": "Leg leveranciersrapportage vast",
      "productCode":"Item nr.",
      "manufacturerPartNumber":"Fabrikantnr.",
      "productName":"EAN/GTIN",
      "gtin":"EAN ",
      "bundle": "Bundel",
      "invoiceDate": "Verkoopdatum",
      "inventoryDate": "Inventarisdatum",
      "quantity": "Menigte",
      "transactionType": "Type",
      "onlineSale":"Online",
      "marketplaceSale":"Marktplaats",
      "productSupplier":"leverancier",
      "YES":"Ja",
      "NO": "Nein",
      "required":"(verplicht)",
      "error":"Record leveranciersrapportage konden niet worden opgevraagd.",
      "dataEvaluationTitle": "Vendor Reporting Detaildaten",
      "storeId": "Filiaal-ID",
      "productCodeType": "Item Nr.-Type",
      "productInfo": "Productgegevens",
      "ringfotoProductCode": "Ringfoto-Nr"
    },
    "messages" :{
      "error":"",
      "deleteSuccess":"Gegevens succesvol verwijderd.",
      "deleteFailure":"",
      "invalidProduct":"Item nr. {{productCode}} niet gevonden. Gelieve te controleren.",
      "saveSuccess":"Gegevens succesvol opgeslagen.",
      "duplicateData": "Item nr. {{productCode}} - Item bestaat al. Controleer!",
      "incorrectData": "Item nr. {{productCode}} kon niet worden toegevoegd. Controleer dit!",
      "invalidInventoryDate":"Item nr. {{productCode}} - Ongeldige inventarisdatum, zou {{inventoryDate}} moeten zijn. Controleer!"
    },
    "instructions": {
      "title": "Anleitung zum Vendor Reporting",
      "informationParagraph": "<p>Gebruiksaanwijzing voor leveranciersrapportages </p> <p>Klik op één van de rapportageregels (het is ook mogelijk om de selectie te filteren op fabrikantnummer, EAN, fabrikant, type, kanaal, artikelnummer of status). </p> <p> Let hierbij op de periode waarvoor je de artikelen moet melden (rapportageperiode) en het tijdstip waarop je de gegevens moet hebben ingevoerd (rapportagedag).</p> <p> <span>Verkoopgegevens (Verkoop)</span>:<br> Voer het filiaal-ID, het Art.Nr.-Typ  en het Art.Nr.  in, evenals bundel, verkoopdatum, aantal (kan niet minder zijn dan 1), type, leverancier, online en marktplaats. <br> <span>Voorraadgegevens</span>:<br> Voer het filiaal-ID, het Art.Nr.-Typ  en het Art.Nr  in, evenals voorraaddatum, hoeveelheid en leverancier (waarbij de voorraaddatum automatisch op de laatste dag van de rapportageperiode wordt gezet). <br> <pVoor het Art.Nr.-Typ  zijn de volgende opties beschikbaar: </p> <ul><li>H = Fabrikant-nr.</li><li>R = Ringfoto-nr.</li><li>E = EAN</li></ul> <p>Zorg ervoor dat de invoer in het veld \u0022Art.Nr\u0022 overeenkomt met de selectie, anders verschijnt er een foutmelding (zelfs als het een geldig nummer van een ander type is). <p> <p> Na het invoeren van de gegevens op Toevoegen (\u0022+\u0022 icoon) klikken en Opslaan - de ingevoerde gegevens worden nu opgeslagen. <br> <br> Wanneer je het rapport opnieuw opent, worden bij de artikelgegevens automatisch het fabrikantnummer, Ringfotonummer, EAN (wijzigingen afhankelijk van het geselecteerde Art.Nr.-Typ ) en de omschrijving weergegeven. <br> <br> Zowel eerder geregistreerde als reeds gerapporteerde gegevens kunnen worden gewijzigd of verwijderd (prullenbaksymbool). </p>",
      "importCsvParagraphTitle": "Importeren via een CSV-bestand:",
      "importCsvParagraph": "Je kunt ook meerdere gegevensrecords tegelijk naar het systeem uploaden door een CSV-bestand te importeren in overeenstemming met de voorbeelden die hier beschikbaar zijn (Verkoop, Voorraad).",
      "importCsvParagraphContinued":  "<p> Om een succesvolle verwerking van het bestand te garanderen, dien je rekening te houden met de volgende punten: </p> <ul> <li> De bestandsnaam moet overeenkomen met de voorbeeldnamen: <a href='assets/files/CanonInventory_xy.csv'>CanonInventory_xy </a> of <a href='assets/files/CanonSales_xy.csv'> CanonSales_xy </a>. </li> <li> In het bestand moeten de recordgegevens op een regel gescheiden worden (scheidingsteken: puntkomma \u0022;\u0022): </li> <ul> <li> Verkoop: <br> Fabrikant; Rekeningnummer; Land; Kanaal; Type; Rapportageperiode; Vestigings-ID; Artikelnr. Type; Artikelnr. Bundel; Verkoopdatum; <br> Aantal; Transactietype; Leverancier; Online; Marktplaats </li><li> Inventaris: <br> Fabrikant;Klant.nr.;Land;Kanaal;Type;Rapportageperiode;filiaal-ID;Art.nr.-type;Art.nr.Voorraaddatum;Aantal;Leverancier<br> Hoeveelheid;Transactietype;Leverancier;Online;Marktplaats) </li> </ul><li> In de onderstaande velden zijn alleen de opgegeven waarden toegestaan: <ul> <li> Kanaal: Algemeen/Winkel/Online</li> <li> Type: voorraad/verkoop</li> <li> Type: H/R/E</li> <li> Bundel: JA/NEE</li> <li> Transactietype: S/R</li> <li> Leverancier: leverancier/andere</li> <li> Online: JA/NEE</li> <li> Marktplaats: JA/NEE </li> </ul> </li> </ul> </li> ",
      "importCsvParagraphAfterTemplate": "<p>Als er een fout optreedt, wordt het complete bestand niet verwerkt.  Een overeenkomstige foutmelding wordt dan weergegeven. Controleer de gegevens en upload deze opnieuw. </p> <p> Elke nacht worden de ingevoerde gegevens verwerkt waarvan de rapportagedag is verstreken. Na een succesvolle overdracht verandert de status in \u0022Succesvol\u0022 of \u0022Fout\u0022 als er tijdens de overdracht iets mis is gegaan. </p> <p> De reeds verzonden berichten kunnen opnieuw in het overzicht worden weergegeven door het selectievakje \u0022Toon  verwerkt\u0022 aan te vinken. Als je op een betreffende rapportageregel klikt, wordt een pop-up met gedetailleerde gegevens in de weergavemodus geopend. Door op \u0022Ingevoerde gegevens wijzigen\u0022 te klikken kun je vervolgens de reeds gerapporteerde gegevens wijzigen/aanvullen, waarna deze de volgende nacht opnieuw worden verwerk </p>",
      "close": "Sluiten"
    },
    "b2bUnit":"Kd.Nr:",
    "reportCategory": "Report-Kategorie",
    "partnerID":"PartnerID",
    "reportCountry":"Land",
    "reportChannel":"Kanaal",
    "dataEvaluation":{
      "noOfRecords":"Anzahl Datensätze:",
      "noOfArticles":"Anzahl Artikel:",
      "noOfDealers":"Anzahl Händler:",
      "noOfQuantity":"Menge gesamt:"
    },
    "productCode":"Artikel-Nr.",
    "manufacturerNumber":"Hersteller-Nr.",
    "ean":"EAN",
    "onlineSale":"Online",
    "salesType":"SALES-TYPE",
    "date":"Datum",
    "rioSortOptions": {
      "label": "Sortieren nach",
      "productCode":"Artikel-Nr.",
      "b2bUnit":"B2BUnit",
      "manufacturerPartNumber":"Hersteller-Nr.",
      "gtin":"EAN",
      "inventoryDate":"Bestandsdatum",
      "date":"Datum"
    },
    "reportCategory": {
      "Daily": "A (Dagelijks)",
      "Weekly": "B (Wekelijks)",
      "Monthly": "C (Maandelijks)"
    }
  }
}

